import * as React from "react";
import Select from "react-select";
import { FormattedMessage } from "react-intl";
import { Modal } from "react-bootstrap";
import { translate } from "@/modules/shared/IntlProviderWrapper";
import ErrorComponent from "@/modules/shared/ui/ErrorComponent";
import type { CalendarLineOption } from "@/lib/models";

type Props = {
    show: boolean;
    onHide: (shift_template: CalendarLineOption | null) => void;
    calendar_line_options: CalendarLineOption[];
};

type State = {
    calendar_line_option: string;
    error: string;
};

class PreplanningEditLineModal extends React.Component<Props, State> {
    state: State = {
        calendar_line_option: "",
        error: "",
    };

    handleTemplateChange = (value: string) => {
        this.setState({ calendar_line_option: value });
    };

    saveCalendarLineOption = async () => {
        if (this.state.calendar_line_option === "") {
            this.setState({ error: translate("common.select_filter_value", "Select value") });
            return;
        }

        const calendar_line_options = this.props.calendar_line_options;

        // find the calendar line option with the same value
        const found = calendar_line_options.find(option => option.value === this.state.calendar_line_option);
        if (found) {
            return this.setState({ calendar_line_option: "" }, () => {
                this.props.onHide(found);
            });
        }
    };

    closeModal = () => {
        this.setState({ calendar_line_option: "" }, () => {
            this.props.onHide(null);
        });
    };

    render() {
        return (
            <Modal show={this.props.show} onHide={() => this.props.onHide(null)}>
                <Modal.Header>
                    <Modal.Title as={"div"}>
                        <h5>
                            {translate("Calendar_line.apply_shift_template_to_line", "Apply shift template to line")}
                        </h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Select
                        className="form-select mb-1"
                        options={this.props.calendar_line_options}
                        onChange={(selectedOption: CalendarLineOption) =>
                            this.handleTemplateChange(selectedOption.value)
                        }
                        value={this.props.calendar_line_options.find(
                            option => option.value === this.state.calendar_line_option
                        )}
                        placeholder={translate("common.select_filter_value", "Select value")}
                    />
                    {this.state.error !== "" ? <ErrorComponent msg={this.state.error} type="error" /> : null}
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={this.saveCalendarLineOption} className="btn btn-primary">
                        <FormattedMessage id="Shifts.apply_template" defaultMessage="Apply template" />
                    </button>
                    <button onClick={this.closeModal} className="btn btn-outline-secondary">
                        <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default PreplanningEditLineModal;
